import * as React from 'react';
import { Box as Box_, BoxProps as BoxProps_, CommonProps, Omit } from 'grid-styled';

interface BoxProps extends CommonProps, Omit<BoxProps_, 'ref'> {
    current?: any;
    fontSize?: number;
    color?: string;
    className?: any;
}
export const Box: React.SFC<BoxProps> = (props) => {
    const { mt, width, children, ...rest } = props;
    return (
        <Box_
            mt={mt || mt === 0 ? mt : 10}
            width={width ? width : '100%'}
            {...rest}
        >
            {children}
        </Box_>
    );
};



// WEBPACK FOOTER //
// ./src/CommonUI/Layout/Box.tsx